import AppRoute from "models/AppRoute"
import { InvoiceImportItemStatus } from "models/InvoiceImportItem"

const InvoiceImportRoute = new AppRoute<{}, { filter: InvoiceImportItemStatus }>({
    route: "/import-invoices",
    navbar: true,
    authRequired: true,
})

export default InvoiceImportRoute
